// src/components/NavConceptItem.js

import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import axios from "@common/axios";
import {UserContext} from "@context/UserContext";
import Switch from "@common/Switch";
import ListItemCore from "@common/ListItemCore";
import {BrandContext} from "@context/BrandContext";
import MathJaxHTMLContent from "@common/MathJaxHTMLContent";

const NavConceptItem = (props) => {
    const {user} = useContext(UserContext);
    const brandConfig = useContext(BrandContext);
    const {className, classId, meta, url, concept, enabled = true, disabled = false, active = false, handleChangeConcept, handleUpdateConcepts, ...other} = props;

    const handleChangeEnabled = (event) => {
        const locEnabled = event.target.checked;
        axios.get('/web/ui/content/enableConceptClass',  {params: {conceptId: concept.conceptId, classId: classId, enabled: locEnabled}})
            .then(response => {
                handleUpdateConcepts(response.data);
            });
    };

    const handleClickConcept = (event) => {
        if (disabled) {
            return;
        }

        if (concept.pdfOnly) {
            openMediaDocument(concept.pdfId);
        } else {
            handleChangeConcept(concept.conceptId);
        }
    };

    const accessibleName = concept.conceptName.replace(/<[^>]*>?/gm, '');

    return (
        <li
            id={`concept-${concept.conceptId}`}
            className={
                'ch-list-item' +
                (active ? ' ch-list-item-active' : '') +
                (className ? ` ${className}` : '') +
                (disabled && !active ? ' ch-list-item-disabled' : '')
            }
        >
            <a
                href={`#${accessibleName}`}
                onClick={(e) => {
                    e.preventDefault();
                    handleClickConcept(e);
                }}
                aria-label={accessibleName}
                tabIndex={disabled ? -1 : 0}
                className={'ch-nav-item'}>
                {brandConfig.disableConcepts && user.teacher && classId > 0 &&
                    <Switch
                        onChange={handleChangeEnabled}
                        onClick={(e) => e.stopPropagation()}
                        size="small"
                        color="primary"
                        name="enabled"
                        checked={enabled}
                        aria-label={`Enable ${brandConfig.conceptName}`}
                    />
                }

                <ListItemCore meta={meta}>
                    <MathJaxHTMLContent showLoader={false} ElementTag={'span'} html={concept.conceptName} />
                </ListItemCore>
            </a>
        </li>
    );
};

NavConceptItem.propTypes = {
    enabled: PropTypes.bool
};

export default NavConceptItem;